
















import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component
export default class PCMenu extends Vue {
  @Prop({required: true})
  menu!: TMenuItem[]
  @Prop({required: true})
  selected!: (route: string) => boolean
}
